import Index from "@frog/source/models/App.js"
import Navigation from "@frog/source/models/Navigation.js"
import Keyb from "keyb"
import Poin from "@frog/source/utility/Pointer.js"
import Delta from "@frog/source/models/Delta.js"
import Stage from "@frog/source/models/Stage.js"
import Audiomix from "@frog/source/models/juice/Audiomix.js"
import Keyset from "@frog/source/utility/Keyset.js"

import * as Motions from "@frog/source/utility/Motions.js"
import Timings from "@frog/source/utility/Timings.js"
import {colortween, tween} from "@frog/source/utility/Tweens.js"

import skills from "@frog/source/data/skills.js"

import animations from "@frog/source/models/juice/animations.js"

export default new class Director {
    constructor() {
        this.steps = []
    }
    add(steps) {
        if(steps instanceof Array == false) {
            steps = [steps]
        }
        steps = steps.map((step) => {
            if(Steps[step.type] != undefined) {
                console.log("%cSupported Step:", "color:black;", step)
                return new Steps[step.type](step)
            } else {
                // console.log("%cUnsupported Step:", "color:red", step)
                return new GenericStep(step)
            }
        })
        this.steps = this.steps.concat(steps)
    }
    update(delta) {
        // delta = {
        //     "s": delta.s / 4,
        //     "ms": delta.ms / 4,
        //     "f": delta.f / 4,
        // }
        if(this.steps[0] != undefined) {
            this.steps[0].update(delta)

            if(this.steps[0].hasFinished) {
                this.steps.shift()
            }
        }

        if(Poin.wasJustPressed("primary", true, delta.ms)
        || Keyb.wasJustPressed("<space>", delta.ms)) {
            this.skip()
        }
    }
    skip() {
        while(this.steps.length > 0
        && this.steps[0].canBeSkipped) {
            this.steps[0].skip()
            this.steps.shift()

            // if(this.steps[0].hasFinished == false) {
            //     if(this.steps[0].skip instanceof Function) {
            //         this.steps[0].skip()
            //     }
            // }
        }
    }
    dump() {
        while(this.steps.length > 0) {
            this.bump()
        }
    }
    get isPerforming() {
        return this.steps.length > 0
    }
}

////////////
// STEPS //
//////////

const SKIP_TIME = 200 // in milliseconds
class Step {
    constructor(that) {
        for(let key in that)  {
            this[key] = that[key]
        }

        this.hasStarted = false
        this.hasFinished = false

        this.time = 0 // in milliseconds
        this.accumulatedTime = 0 // in milliseconds

        this.sequence = []

        if(this.alphastage != undefined) {
            this.stage = Stage.copy(this.alphastage)
        }
    }
    update(delta) {
        this.hasStarted = true

        this.time += delta.ms
        this.accumulatedTime += delta.ms

        while(this.sequence.length > 0) {
            if(this.sequence[0] instanceof Function) {
                this.sequence[0].call()
                this.sequence.shift()
                continue
            }
            if(this.sequence[0].execute instanceof Function) {
                this.sequence[0].execute(this.time)
            }
            if(this.sequence[0].duration != undefined) {
                if(this.accumulatedTime > this.sequence[0].duration) {
                    this.accumulatedTime -= this.sequence[0].duration
                    this.sequence.shift()
                    continue
                } else {
                    break
                }
            }
            // else {
            // this.sequence.shift()
            // continue
            // }
            if(this.sequence[0].condition != undefined) {
                if(!!this.sequence[0].condition()) {
                    this.sequence.shift()
                    continue
                } else {
                    break
                }
            }
            // if(this.sequence[0].isUnskippable == true) {
            //     this.sequence.shift()
            //     return
            // }
        }

        if(this.sequence.length == 0) {
            this.finish()
        }
    }
    skip() {
        while(this.sequence.length > 0) {
            // if(this.sequence[0].isUnskippable != undefined) {
            //     return
            // }
            // if(this.sequence[0].condition != undefined) {
            //     return
            // }
            if(this.sequence[0] instanceof Function) {
                this.sequence[0]()
            }
            this.sequence.shift()
        }
        this.finish()
    }
    finish() {
        this.hasFinished = true

        if(this.onFinish instanceof Function) {
            this.onFinish()
        }
    }
    get canBeSkipped() {
        return this.time > SKIP_TIME
    }
    static generateAnimatedSequence({animation, stage}) {
        animation.maxmark = 0
        animation.timelines = {}
        animation.keyframes.forEach((keyframe) => {
            Object.keys(keyframe).forEach((key) => {
                if(key == "key"
                || key == "mark"
                || key == "type"
                || key == "timing"
                || key == "motion") {
                    return
                }

                // keyframe has many properties.
                // key == property key

                const timelineKey = (keyframe.key !== undefined ? keyframe.key + "." : "") + key

                animation.timelines[timelineKey] = animation.timelines[timelineKey] || []
                animation.timelines[timelineKey].push({
                    "key": keyframe.key,
                    "mark": keyframe.mark,
                    "type": keyframe.type,
                    "timing": keyframe.timing,
                    "motion": keyframe.motion,
                    [key]: keyframe[key]
                })
            })

            if(animation.maxmark < keyframe.mark) {
                animation.maxmark = keyframe.mark
            }
        })
        // console.log(JSON.stringify(animation.timelines["audio"]))
        // console.log(animation.timelines) // DEBUG

        Keyset.forEach(animation.timelines, (timeline) => {
            timeline.sort((a, b) => {
                if(a.mark < b.mark) return -1
                if(a.mark > b.mark) return +1
                return 0
            })
        })

        return [{
            "duration": animation.duration || animation.maxmark,
            "execute": function(currentDuration) {
                const tweenFrame = {"mark": currentDuration}

                if(animation.timelines != undefined) {
                    Keyset.forEach(animation.timelines, (timeline) => {
                        // TODO: iterate through as many keyframes in this timeline as
                        // need to, in case there are many keyframes for this single
                        // property all happening at the same time.
                        if(timeline[1] != undefined
                        && timeline[1].mark < tweenFrame.mark) {
                            // Step.performFrame(stage, timeline[0])
                            // Step.performFrame(stage, timeline[1])
                            timeline.shift()
                            return
                        }
                        if(timeline[0] == undefined) {
                            return
                        }
                        if(timeline[0].mark > tweenFrame.mark) {
                            return
                        }

                        if(timeline[0].type == "log") {
                            Step.performFrame(stage, timeline[0])
                            timeline.shift()
                            return
                        }

                        if(timeline[0].createUnit != undefined) {
                            Delta.editStage(stage, {
                                "units": [
                                    timeline[0].createUnit
                                ]
                            })
                            timeline.shift()
                            return
                        }

                        // only execute once!
                        if(timeline[0].health != undefined) {
                            const unit = stage.units[timeline[0].key]
                            unit.transform = unit.transform || {}
                            unit.transform.health = unit.transform.health || 0
                            unit.transform.health += timeline[0].health
                            timeline.shift()
                            return
                        }

                        // // TODO: Only trigger these once.
                        // if(events[currentKeyframe.event] instanceof Function) {
                        //     events[currentKeyframe.event]()
                        // }
                        if(timeline[0].type == "audio") {
                            if(timeline[0].audio.triggerKey != undefined) {
                                Audiomix.trigger(timeline[0].audio.triggerKey)
                            }
                            timeline.shift()
                            return
                        }

                        const previousFrame = timeline[0]
                        const nextFrame = timeline[1]
                        Step.performFrame(stage, previousFrame, tweenFrame, nextFrame)
                    })
                }
            }
        }]
    }
    static performFrame(stage, previousFrame, tweenFrame, nextFrame) {
        tweenFrame = tweenFrame || previousFrame
        nextFrame = nextFrame || previousFrame

        const progress = Math.min(1, (tweenFrame.mark - previousFrame.mark) / (nextFrame.mark - previousFrame.mark))
        const timing = nextFrame.timing || Timings.linear
        const motion = nextFrame.motion || Motions.line

        // WHAT HAPPENS IF THE POSITION IS NOT DEFINED AND WE
        // STILL TRY TO TWEEN IT? BE SURE TO DEFAULT OR ABORT.
        if(previousFrame.type == "particle") {
            stage.particles = stage.particles || {}
            stage.particles[previousFrame.key] = stage.particles[previousFrame.key] || {}
            if(previousFrame.image != undefined) {
                stage.particles[previousFrame.key].image = previousFrame.image
            }
            if(previousFrame.scale != undefined) {
                if(nextFrame.scale != undefined) {
                    stage.particles[previousFrame.key].scale = tween(previousFrame.scale, nextFrame.scale, timing(progress))
                } else {
                    stage.particles[previousFrame.key].scale = previousFrame.scale
                }
            }
            if(previousFrame.position != undefined && nextFrame.position != undefined) {
                stage.particles[previousFrame.key].position = motion(previousFrame.position, nextFrame.position, timing(progress))
            }
            if(previousFrame.rotation != undefined && nextFrame.rotation != undefined) {
                stage.particles[previousFrame.key].rotation = tween(previousFrame.rotation, nextFrame.rotation, timing(progress))
            }
            if(previousFrame.delete == true) {
                delete stage.particles[previousFrame.key]
            }
            return
        }

        if(previousFrame.type == "log") {
            stage.logs = stage.logs || []
            stage.logs.push({
                "text": previousFrame.text,
            })
            return
        }

        const unit = stage.units[previousFrame.key]
        if(unit == undefined) {
            return
        }
        if(previousFrame.rotation != undefined && nextFrame.rotation != undefined) {
            unit.rotation = tween(previousFrame.rotation || 0, nextFrame.rotation || 0, timing(progress))
        }
        if(previousFrame.opacity != undefined && nextFrame.opacity != undefined) {
            unit.opacity = tween(previousFrame.opacity, nextFrame.opacity, timing(progress))
        }
        if(previousFrame.position != undefined && nextFrame.position != undefined) {
            // if(previousFrame.position.mode == "absolute"
            if(nextFrame.position.mode == "absolute") {
                unit.position = motion(previousFrame.position, nextFrame.position, timing(progress))
            } else {
                unit.transform = unit.transform || {}
                unit.transform.position = motion(previousFrame.position, nextFrame.position, timing(progress))
            }
        }
        unit.transform = unit.transform || {}
        unit.transform.rotate = tween(previousFrame.rotate || 0, nextFrame.rotate || 0, timing(progress))
        unit.transform.graycalse = tween(previousFrame.grayscale || 0, nextFrame.grayscale || 0, timing(progress))
        if(previousFrame.health != undefined) {
            unit.transform.health = unit.transform.health || 0
            unit.transform.health += previousFrame.health
            // TODO: THIS FEELS LIKE DELTA.EDITUNIT SORT OF STUFF!!
            // ALSO! THIS IS ONLY RUN ONCE BECAUSE IT IS A MUTATION!
        }
    }
}

const Steps = {}

class GenericStep extends Step {
    constructor(step) {
        super(step)

        this.sequence = [
            () => Delta.editStage(this.stage, step.deltastages),
            // {"duration": 0.5},
        ]
    }
}

Steps["exhaust energy"] = class extends Step {
    constructor(step) {
        super(step)

        this.sequence = [
            () => Delta.editStage(this.stage, step.deltastages)
        ]

        // const keys = Object.keys(step.deltastages[0].units).filter((key) => {
        //     const unit = step.omegastage.units[key]
        //     return unit.energy["move"] === false
        //         && unit.energy["invoke skill"] === false
        //         && unit.affiliation !== "bad" // skip animation for bad units
        // })
        // if(keys.length > 0) {
        //     this.sequence = Step.generateAnimatedSequence({
        //         "animation": animations["exhaust energy"](step),
        //         "stage": this.stage,
        //     })
        // } else {
        //     this.sequence = []
        // }
    }
}

Steps["start turn"] = class extends Step {
    constructor(step) {
        super(step)

        this.sequence = [
            () => Delta.editStage(this.stage, step.deltastages),
            // () => this.isRenderingBanner = true,
            // {"duration": 1},
        ]
    }
}

// TODO: like, if it is just performing the deltastage without
// any sort of animation, why have a unique individual step??
// we have moved the responsibilities of transforming parameters
// into the step.deltastages, and all the animation in animation.
Steps["spawn"] = class extends Step {
    constructor(step) {
        super(step)

        this.sequence = [
            () => Delta.editStage(this.stage, step.deltastages),
        ]
    }
}

Steps["success modal"] = class extends Step {
    constructor(step) {
        super(step)

        this.sequence = [
            // () => Navigation.state.modal = {"type": "success", "step": 0},
            // {"duration": 1},
            () => console.log("Success!!", Index.game.encounter.slug),
            () => GameAnalytics.reportStageSuccess(Index.game.encounter.slug),
            // () => Navigation.state.modal = {"type": "success", "step": 1},
            // {"duration": 1},
            // {"condition": () => Navigation.state.modal.hasClickedContinue == true},
            // () => Navigation.state.modal = undefined,
        ]
    }
}

Steps["failure modal"] = class extends Step {
    constructor(step) {
        super(step)

        this.sequence = [
            () => Navigation.state.modal = {"type": "failure"},
            () => console.log("Failure...", Index.game.encounter.slug),
            () => GameAnalytics.reportStageFailure(Index.game.encounter.slug),
            {"duration": 1},
            {"condition": () => Navigation.state.modal.hasClickedContinue == true},
            () => Navigation.state.modal = undefined,
            // () => window.location.reload(), // TODO: respect Navigation.load
        ]
    }
}

Steps["navigate"] = class extends Step {
    constructor(step) {
        super(step)

        // TODO: this needs to respect Navigation.load
        this.sequence = [
            () => Navigation.state.isTransitioning = true,
            {"duration": 0.25 * 1000},
            () => Navigation.load(step.path), // TOOD: holy hardcoding batman
            {"duration": 1.5 * 1000},
            () => Navigation.state.isTransitioning = false,
        ]
    }
}

import GameAnalytics from "not-game-analytics"

Steps["load encounter"] = class extends Step {
    constructor(step) {
        super(step)

        // TODO: this needs to respect Navigation.load
        this.sequence = [
            () => Navigation.state.isTransitioning = true,
            () => console.log("Loading encounter", step.encounter.slug),
            () => GameAnalytics.reportStageStart(step.encounter.slug),
            {"duration": (1 * 0.25) * 1000},
            () => Navigation.state.screen = "EncounterScreen",
            () => Index.load({
                "game": {
                    "encounter": step.encounter
                }
            }),
            {"duration": (1 * 0.75) * 1000},
            () => Navigation.state.isTransitioning = false,
        ]
    }
}

Steps["invoke skill"] = class extends Step {
    constructor(step) {
        super(step)

        // const direction = getDirection(step.action.previousPosition, step.action.position)
        // if(direction.x == 0 && direction.y == 0) {
        //     return
        // }

        let animation = animations["default"]
        if(step.skillKey != undefined
        && skills.get(step.skillKey) != undefined
        && skills.get(step.skillKey).animation != undefined
        && animations[skills.get(step.skillKey).animation] != undefined) {
            animation = animations[skills.get(step.skillKey).animation]
        }

        this.sequence = Step.generateAnimatedSequence({
            "animation": animation(step),
            "stage": this.stage,
        })
    }
}

Steps["move"] = class extends Step {
    constructor(step) {
        super(step)

        // let toBeSkipped = false
        // step.deltastages.forEach((deltastage) => {
        //     if(deltastage.units == undefined) return
        //     Keyset.forEach(deltastage.units, (deltaunit, unitKey) => {
        //         if(step.alphastage.units[unitKey].affiliation == "good") {
        //             toBeSkipped = true
        //         }
        //     })
        // })
        // if(toBeSkipped) {
        //     return
        // }

        this.sequence = Step.generateAnimatedSequence({
            "animation": animations["move"](step),
            "stage": this.stage,
        })
    }
    get canBeSkipped() {
        if(this.isStartingMovement) {
            return this.time > SKIP_TIME
        } else {
            return true
        }
    }
}

Steps["death"] = class extends Step {
    constructor(step) {
        super(step)

        this.sequence = Step.generateAnimatedSequence({
            "animation": animations["death"](step),
            "stage": this.stage,
            // "units": {
            //     "all": Object.keys(step.deltastagesssssss.units).map((key) => this.stage.units.find((unit) => unit.key == key))
            // }
        })
    }
}

Steps["escape"] = class extends Step {
    constructor(step) {
        super(step)

        this.sequence = Step.generateAnimatedSequence({
            "animation": animations["escape"](step),
            "stage": this.stage,
        })
    }
}
